<template>
  <section class="singel-doc-page box pt-5">
    <BackButtonSingelPage class="mb-3" path="/account/orders" />
    <div v-if="theOrder !== null" class="OrderView d-flex flex-column ga-4">
      <DocInfo
        @set-has-change="setHasChange"
        :docNumber="cartOrOrder"
        :docTypeName="$t('SingleOrder.OrderNumber')"
        :editable="(editable && isOnEditOrderMode) || iscart"
        :theDoc="theOrder"
        :iscart="iscart"
        :mode="mode"
        :shipTypes="getShipTypes"
        @edit-doc-reference="changeTheDocReference"
        @selectChoice="changeTheDocShippingCode"
      >
        <template
          v-if="this?.theOrder?.link && !isOnEditOrderMode"
          #top-left-action-btn
        >
          <BaseButton
            @click="downloadPdf"
            paddingTop="8px"
            paddingBottom="8px"
            paddingLeft="10px"
            paddingRight="10px"
          >
            <v-icon
              class="ml-1"
              size="18"
              color="white"
              icon="mdi-file-download-outline"
            />
            <span class="btn-text">{{
              $t("SingleOrder.downloadPdfButtn")
            }}</span>
          </BaseButton>
        </template>
      </DocInfo>
      <!-- {{ this.$store.getters["Orders/getOrder"](this.cartOrOrder).OrderLines }} -->
      <!-- {{ this.theOrder }} -->
      <DocProducts
        :docTypeName="$t('SingleOrder.orderDetails')"
        :orderLines="theOrder.OrderLines"
        :mode="mode"
        :isQuantityBtnDisable="isQuantityBtnDisable"
        :editable="isOnEditOrderMode || iscart"
        @setEditMode="setEditMode"
        @updateLineInfo="updateLineInfo"
      >
        <template #doc-summary>
          <InnerBox
            v-if="theOrder?.OrderLines?.length > 0"
            :fontWeight="700"
            class="order-summary"
            :title="$t('SingleOrder.orderSummaryTitle')"
          >
            <template #content>
              <div class="d-flex flex-column ga-2">
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingleOrder.orderCountItems") }}</label>
                  <span>{{ orderItemsCount }}</span>
                </div>
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingleOrder.orderPackagesCount") }}</label>
                  <span>{{ theOrder.OrderLines.length ?? 0 }}</span>
                </div>
                <span class="my-2 seperate-line" />
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingleOrder.priceBeforeTax") }}</label>
                  <span
                    >{{ currency
                    }}{{
                      formatPrice(
                        isOrderHasDiscount
                          ? priceBeforeDiscount
                          : theOrder.totalWithOutVat
                      )
                    }}</span
                  >
                </div>
                <div
                  v-if="customerDiscountPercent !== 0"
                  class="d-flex justify-space-between order-info"
                >
                  <label
                    >{{ $t("SingleOrder.priceInludeDiscount") }}
                    {{ `${customerDiscountPercent}%` }}</label
                  >
                  <span
                    >{{ currency }}{{ formatPrice(priceInludeDiscount) }}</span
                  >
                </div>
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("SingleOrder.tax") }} {{ `${tax}%` }}</label>
                  <span
                    >{{ currency }}{{ formatPrice(totalVatWithDiscount) }}</span
                  >
                </div>
                <div class="d-flex justify-space-between order-info">
                  <label>{{ $t("ProductWidget.priceIncludeTax") }}</label>
                  <span
                    >{{ currency
                    }}{{ formatPrice(totalAmountWithDiscount) }}</span
                  >
                </div>
              </div>
            </template>
          </InnerBox>
        </template>
      </DocProducts>
      <DocNotes
        :mode="mode"
        :note="theOrder?.notes"
        :editable="editable || iscart"
        v-model="newDocNotes"
      />
      <OrderButtons
        :iscart="iscart"
        :editable="editable"
        :orderLinesLength="theOrder?.OrderLines?.length"
        @cancel-edit="cancelOrderEdit"
        @update-changes="updateChanges"
        @send-order="sendOrderToPriority"
      />
    </div>
    <SendOrderSuccessModal v-model="isSendOrderSuccessModalOpen" />
    <SendOrderFailedModal v-model="isSendOrderFailedModalOpen" />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import store from "../../store";
import DocInfo from "../helpers/DocInfo.vue";
import DocNotes from "../helpers/DocNotes.vue";
import DocProducts from "../helpers/DocProducts.vue";
import OrderButtons from "../helpers/OrderButtons.vue";
import SendOrderSuccessModal from "../UI/modals/SendOrderSuccessModal.vue";
import SendOrderFailedModal from "../UI/modals/SendOrderFailedModal.vue";
import InnerBox from "../UI/InnerBox.vue";
import BackButtonSingelPage from "../UI/BackButtonSingelPage.vue";
import BaseButton from "../UI/BaseButton.vue";

export default {
  components: {
    // BaseLightBox,
    DocInfo,
    DocNotes,
    DocProducts,
    InnerBox,
    OrderButtons,
    SendOrderSuccessModal,
    SendOrderFailedModal,
    BackButtonSingelPage,
    BaseButton,
  },
  mounted() {
    // console.log(this.);
    this.getOrderOrCart();
    // this.setMainAddres(this.Sites);

    // for the text of modal
  },
  data() {
    return {
      theOrder: null,
      cartOrOrder: "",
      iscart: false,
      hasDeliveries: false,
      editable: false,
      activeOrder: false,
      hasChanges: false,
      orderEmpty: false,
      savedBeforeSendOrder: false,
      orderNumber: "",
      newDocReference: "",
      newDocShippingCode: "",
      newDocNotes: "",
      isOnEditOrderMode: false,
      currency: "₪",
      isQuantityBtnDisable: false,
      isSendOrderSuccessModalOpen: false,
      isSendOrderFailedModalOpen: false,
    };
  },
  watch: {
    theOrder() {
      if (this.editable && typeof this.theOrder.User != "undefined") {
        this.selectedContactUser = this.theOrder.User.phone;
      }
    },
    newDocNotes: {
      immediate: false,
      handler() {
        this.theOrder.notes = this.newDocNotes;
        // console.log(this.theOrder.notes);
      },
    },
  },
  methods: {
    setEditMode(value) {
      this.isOnEditOrderMode = value;
    },
    downloadPdf() {
      if (this?.theOrder?.link) {
        window.open(this.theOrder.link, "_blank");
      }
    },
    formatPrice(price) {
      if (!isNaN(price)) {
        return Number(price).toFixed(1);
      }
      return "0";
    },
    async updateLineInfo(updatedLine) {
      if (this.iscart) {
        this.isQuantityBtnDisable = true;
        var { quant } = updatedLine;
        var line = updatedLine;
        if (quant) {
          await this.$store.dispatch("Orders/updateCart", line);
        } else {
          await this.$store.dispatch("Orders/removeProductFromCart", line);
        }
        this.theOrder = {
          ...this.$store.getters["Orders/getOrder"](this.cartOrOrder),
        };
        this.isQuantityBtnDisable = false;
      } else {
        // update the orderline in the theOrder var
        const orderLineIndex = this.theOrder.OrderLines.findIndex(
          (orderLine) => orderLine.id === updatedLine.id
        );
        this.theOrder.OrderLines[orderLineIndex] = updatedLine;
      }
    },
    cancelOrderEdit() {
      this.isOnEditOrderMode = false;
    },
    setHasChange(isHasChange) {
      this.hasChanges = isHasChange;
    },
    async updateChanges() {
      if (!this.isOnEditOrderMode) {
        this.isOnEditOrderMode = true;
        return;
      }
      await this.SaveChanges();
      this.isOnEditOrderMode = false;
      // this.hasChanges = false;
      // this.savedBeforeSendOrder = false;
    },
    changeTheDocShippingCode(newDocShippingCode) {
      this.newDocShippingCode = newDocShippingCode;
      this.theOrder.destcode = newDocShippingCode?.stcode;
      console.log("this.theOrder.destcode");

      console.log(this.theOrder.destcode);
    },
    changeTheDocReference(newDocReference) {
      this.newDocReference = newDocReference;
      console.log(this.newDocReference);
    },
    async sendOrderToPriority() {
      if (this.hasChanges) {
        this.savedBeforeSendOrder = true;
      } else if (!this.theOrder.OrderLines?.length) {
        this.orderEmpty = true;
        setTimeout(() => {
          this.orderEmpty = false;
        }, 3000);
      } else {
        this.theOrder.totprice = this.priceIncludeTaxSum;
        this.orderSucceededModalVisability = true;
        const response = await this.$store.dispatch(
          "Orders/sendOrderToPriority",
          this.theOrder
        );

        if (response.id) {
          this.isSendOrderSuccessModalOpen = true;
          // alert("הזמנה נשלחה בהצלחה");
          this.hasChanges = false;
        } else {
          this.isSendOrderFailedModalOpen = true;
          // alert("שגיאה בשליחת הזמנה נא לנסות מאוחר יותר");
        }
      }
    },
    deleteOrderLine(orderLine) {
      const answer = window.confirm("האם למחוק את השורה מההזמנה?");
      if (answer) {
        this.removeOrderLine(orderLine);
      }
    },
    async getOrderOrCart() {
      console.log("getOrderOrCart");
      if (this.$route.name == "cart") {
        this.cartOrOrder = "cart";
        this.iscart = true;
        this.editable = true;
        this.theOrder = {
          ...this.$store.getters["Orders/getOrder"](this.cartOrOrder),
        };
      } else {
        this.cartOrOrder = this.$route.params.orderId;
        this.iscart = false;
        this.theOrder = {
          ...this.$store.getters["Orders/getOrder"](this.cartOrOrder),
        };
        if (!Object.keys(this.theOrder).length) {
          this.theOrder = await this.$store.dispatch(
            "Orders/getOrder",
            this.cartOrOrder
          );
        }
        this.hasDeliveries =
          this.theOrder.Deliveries?.length > 0 ? true : false;
        this.editable = this.theOrder?.Status?.editable;
        this.activeOrder = this.theOrder?.Status?.activeorder;
        console.log("theOrder:", this.theOrder);
      }
    },
    async SaveChanges() {
      console.log("tring updating the order data...");
      try {
        this.theOrder.isJobPending = true;
        await store.dispatch("Orders/updateOrder", this.theOrder);
        this.isSendOrderSuccessModalOpen = true;
        // alert("הזמנה עודכנה בהצלחה");
      } catch (err) {
        this.isSendOrderFailedModalOpen = true;
        console.log(err);
        this.isSendOrderFailedModalOpen = true;
      }
    },
    ...mapActions({
      toggleFavorite: "Parts/toggleFavorite",
      removeOrderLine: "Orders/removeOrderLine",
      updateOrderLine: "Orders/updateOrderLine",
    }),
  },
  computed: {
    totalAmountWithDiscount() {
      return this.theOrder.amount;
    },
    totalVatWithDiscount() {
      if (this.customerDiscountPercent !== 0) {
        const discountedPrice = this.priceInludeDiscount;
        return (discountedPrice * this.tax) / 100;
      }
      return this.theOrder.totalVat;
    },
    priceInludeDiscount() {
      let discountCalc = this.priceBeforeDiscount - this.theOrder?.amount;
      if (this.theOrder?.tax) {
        discountCalc =
          this.priceBeforeDiscount - this.theOrder?.totalWithOutVat;
      }
      return discountCalc < 0 ? discountCalc * -1 : discountCalc;
    },
    customerDiscountPercent() {
      return this.theOrder?.discountPercent || 0;
    },
    isOrderHasDiscount() {
      return this.theOrder.discountPercent > 0;
    },
    mode() {
      return this.iscart ? "cart" : "orders";
    },
    priceBeforeDiscount() {
      return this.theOrder.OrderLines.reduce((acc, line) => {
        return acc + line?.partPrice * line.quant;
      }, 0);
    },
    tax() {
      return this.theOrder.tax;
    },
    priceIncludeTaxSum() {
      return (1 + this.getTaxPercent.taxpercent / 100) * this.priceBeforeTaxSum;
    },
    priceBeforeTaxSum() {
      return this.theOrder.OrderLines.reduce((acc, line) => {
        if (this.iscart) {
          return acc + line.Part.originPrice * line.quant;
        } else {
          return (
            acc +
            (line.basePrice /
              parseFloat(
                (1 + this.getTaxPercent.taxpercent / 100).toFixed(2)
              )) *
              line.quant
          );
        }
      }, 0);
    },
    orderItemsCount() {
      return this.theOrder.OrderLines.reduce((acc, line) => {
        return acc + line.quant;
      }, 0);
    },
    ...mapGetters({
      Sites: "Sites/getSites",
      getParts: "Parts/getParts",
      getShipTypes: "shipTypes/getShipTypes",
      getUserPhone: "AuthModule/getUserPhone",
      getCustData: "AuthModule/getCustomerData",
      getTaxPercent: "Orders/getTaxPercent",
      isLoading: "isLoading",
    }),
  },
};
</script>

<style scoped lang="scss">
// .singel-doc-page {
//   max-width: 1400px !important;
// }

.order-summary {
  max-width: 360px;

  label {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    color: $DeepGray;
  }

  span {
    font-size: $mediumTextSize;
    font-weight: 500;
    line-height: 21.33px;
    text-align: right;
    color: black;
  }
}
.inner-box-title {
  font-weight: 700 !important;
}

.order-butttons-container {
  display: flex;
  gap: 20px;
}

@media only screen and (max-width: 601px) {
  .order-butttons-container {
    justify-content: space-around;
  }
}

.shipping-info {
  display: flex;
  gap: 30px;
}

.shipping-actions {
  display: grid;
  grid-row-gap: 10px;
}

.shipping-address,
.shipping-number {
  font-size: $smallTextSize;
}
.shipping-number {
  font-weight: 600;
}
.shipping-date {
  font-size: $extraSmallTextSize;
}
.light-box-headline {
  margin-bottom: 30px;
}
p {
  margin: 0;
}

select {
  display: block;
  border-radius: 10px;
  border-color: lightgrey;
  font-size: $mediumTextSize;
  font-weight: 400;
  line-height: 21.33px;
  text-align: right;
}

.inner-box {
  textarea {
    border: unset;
  }
  input {
    border: unset !important;
  }
}
textarea {
  height: 9rem;
  border-radius: 7px;
  padding: 15px;
  border-color: #dbdbdb;
  width: 100%;
}
textarea:focus {
  outline: none !important;
  border: 1px solid #6daf2d57;
  box-shadow: 0 0 10px #6daf2d69;
}

h1 {
  font-size: $largTextSize;
  font-weight: 600;
}

.doc-number-title {
  font-weight: 400;
  color: $orderLineColor;
}

input[type="date"],
input[type="text"] {
  width: 33% !important;
  display: inline !important;
  font-size: $smallTextSize !important;
}

@media (max-width: 601px) {
  .OrderView > div {
    margin-bottom: 40px !important;
  }
  .row .col:last-child {
    padding-right: 10px !important;
  }
}
.shipping-actions a {
  font-size: $smallTextSize !important;
  background: $secondaryBackgroundButtonColor !important;
}
.shipping-actions {
  margin-top: 20px !important;
}
.send-order {
  display: inline-flex;
  align-items: center;

  font-size: $mediumTextSize;
  background: $cartMainColor;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: right;
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 15px;
  padding: 25px;
  color: white;
  max-width: max-content;

  border: i {
    margin-right: 10px;
  }
  i:lang(en) {
    padding-right: 10px;
    transform: rotate(180deg);
  }
}

@media only screen and (max-width: 601px) {
  .send-order:first-of-type {
    max-width: unset !important;
    width: 100% !important;
  }
}

.send-order.orders {
  background: $ordersMainColor !important;
  font-size: $smallTextSize !important;
  padding-bottom: 27px;
}

.seperate-line {
  height: 1px;
  background: var(--Lite-Grey, #dcdcdc);
}

.btn-text {
  font-size: $smallTextSize;
  font-weight: 400;
}
</style>
